import $i18n from '@alife/panda-i18n';
/**
 * @author: yanhoup
 * @description: 出库常量
 */

// 出库服务器地址
const OUTBOUND = 'outbound';

/**
 * @description 分拣状态
 */
const SORT_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'ASSORTING',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'FINISHED',
  },

  {
    label: $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
    value: 'IDLE',
  },
];

/**
 * @description 分拣状态
 */
const DELIVER_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'ToBeFinished.four_px', dm: '待完结' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'Finished.four_px', dm: '完结中' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完结' }),
    value: 'C',
  },
];

/**
 * 发货作业单状态
 */
const DELIVER_ORDER_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'NotStarted.four_px', dm: '未开始' }),
    value: 'W',
  },
];

/**
 * @description 装车状态
 */
const DISPATCHCAR_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'LOADING',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'COMPLETED',
  },
];

/**
 * @description 订单类型
 */
const ORDER_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: 'MOS',
    value: 'MOS',
  },

  {
    label: 'MOD',
    value: 'MOD',
  },

  {
    label: 'SO',
    value: 'SO',
  },

  {
    label: 'MOD-AGG',
    value: 'MOD-AGG',
  },
];

/**
 * @description 拣选汇波-订单类型
 */
const PICK_ORDER_STATUS = [
  {
    label: 'SO',
    value: 'SO',
  },

  {
    label: 'MOS',
    value: 'MOS',
  },

  {
    label: 'MOD',
    value: 'MOD',
  },

  {
    label: 'Special',
    value: 'S',
  },
];

/**
 * @description 自动汇波-订单类型
 */
const AUTO_WAVE_ORDER_TASK_TYPE = [
  {
    label: 'SO',
    value: 'SO',
  },

  {
    label: 'MOD',
    value: 'MOD',
  },

  {
    label: 'Special',
    value: 'S',
  },
];

/**
 * @description 拣选作业单号-订单类型
 */
const PICK_ORDER_STATUSTER = [
  {
    label: 'SO',
    value: 'SO',
  },

  {
    label: 'MOS',
    value: 'MOS',
  },

  {
    label: 'MOD',
    value: 'MOD',
  },

  {
    label: 'Special',
    value: 'S',
  },

  {
    label: 'MOSS',
    value: 'MOSS',
  },

  {
    label: 'MODS',
    value: 'MODS',
  },

  {
    label: 'MOD-AGG',
    value: 'MOD-AGG',
  },
];

/**
 * @description 拣选单结构
 */
const PICK_STRUCTURE = [
  {
    label: $i18n.get({ id: 'Seckill.four_px', dm: '秒杀' }),
    value: 'seckill',
  },

  {
    label: $i18n.get({ id: 'NormalStructure.four_px', dm: '散单' }),
    value: 'normal',
  },
];

/**
 * @description 拣选单结构
 */
const PICK_SOURCE = [
  {
    label: $i18n.get({ id: 'M_V1.four_px', dm: '手工V1' }),
    value: 'M_V1',
  },

  {
    label: $i18n.get({ id: 'M_V2.four_px', dm: '手工' }),
    value: 'M_V2',
  },
  {
    label: $i18n.get({ id: 'A_V1.four_px', dm: '自动V1' }),
    value: 'A_V1',
  },

  {
    label: $i18n.get({ id: 'A_V2.four_px', dm: '自动V2' }),
    value: 'A_V2',
  },
];

/**
 * @description sku分组-订单类型
 */
const SKU_GROUP_ORDER_STATUS = [
  {
    label: 'SO',
    value: 'SO',
  },
  {
    label: 'MOD',
    value: 'MOD',
  },
];

/**
 * @description 库区类型
 */
const ZONECODE_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'AgvZone.four_px', dm: 'AGV区' }),
    value: 'AGV',
  },

  {
    label: $i18n.get({ id: 'ManualArea.four_px', dm: '人工区' }),
    value: 'HUMAN',
  },
];

/**
 * @description 手工汇波 --- 时间
 */
const MANUALREMIT_TIME = [
  {
    label: $i18n.get({ id: 'ReviewTime.four_px', dm: '审核时间' }),
    value: 'approveTime',
  },

  {
    label: $i18n.get({ id: 'EstimatedOutboundTime.four_px', dm: '预计出库时间' }),
    value: 'expectedOutboundTime',
  },

  {
    label: $i18n.get({ id: 'CustomerPickUpTime.four_px', dm: '客户自提时间' }),
    value: 'pickDate',
  },
];

/**
 * @description 渠道
 */
const CHANNEL = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: 'DHL 1000',
    value: '1',
  },

  {
    label: 'GLS 500',
    value: '2',
  },

  {
    label: 'DPD 400',
    value: '3',
  },

  {
    label: 'FEDEX 30',
    value: '4',
  },
];

/**
 * @description 渠道
 * 小件
  CargoType_S("S", "T25"),
  中件
  CargoType_M("M", "T50"),
  大件
  CargoType_L("L", "T120"),
  超大件
  CargoType_O("O", "T240"),
  特大件
  CargoType_W("W", "TM");
 */
const CARGO_TYPE = [
  {
    label: 'T25',
    value: '1',
  },

  {
    label: 'T50',
    value: '2',
  },

  {
    label: 'T120',
    value: '3',
  },

  {
    label: 'T240',
    value: '4',
  },

  {
    label: 'TM',
    value: '5',
  },
];

/**
 * @description 库区
 */
const WAREHOUSE_AREAR = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: 'A',
    value: 'A',
  },

  {
    label: 'B',
    value: 'B',
  },
];

/**
 * @description 订单来源
 */
const ORDER_ORIGIN = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: 'EBAY',
    value: 'A',
  },

  {
    label: 'AE',
    value: 'B',
  },

  {
    label: 'GFC',
    value: 'B',
  },

  {
    label: 'API',
    value: 'B',
  },
];

/**
 * @description 拣选队列列表搜索
 * Q队列/P拣选/C周转/O出库
 */
const PICK_SEARECH = [
  {
    label: $i18n.get({ id: 'JXBCH.PickingNumber.four_px', dm: '拣选波次号' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'OutboundOrderNo.four_px', dm: '出库单号' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'ContainerNumber.four_px', dm: '容器号' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'PickingJobNo.four_px', dm: '拣选作业单号' }),
    value: 'Q',
  },
];

/**
 * @description 拣选队列列表搜索
 * Q队列/P拣选/C周转/O出库
 */
const PICK_DETAIL_SEARECH = [
  {
    label: $i18n.get({ id: 'JXBCH.PickingNumber.four_px', dm: '拣选波次号' }),
    value: 'P',
  },

  // {
  //   label: $i18n.get({ id: 'OutboundOrderNo.four_px', dm: '出库单号' }),
  //   value: 'O',
  // },

  {
    label: $i18n.get({ id: 'ContainerNumber.four_px', dm: '容器号' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'PickingJobNo.four_px', dm: '拣选作业单号' }),
    value: 'Q',
  },
];

/**
 * @description 拣选状态
 */
const PICK_TAB_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'ToBeSelected.four_px', dm: '待拣选' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'Picking.four_px', dm: '拣选中' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'YJX.Selected.four_px', dm: '已拣选' }),
    value: 'C',
  },
];

/**
 * @description 拣选异常table
 */
const PICK_ABNORMAL_TAB = [
  {
    label: $i18n.get({ id: 'AbnormalPicking', dm: '拣货异常' }),
    value: 'abnormal',
  },

  {
    label: $i18n.get({ id: 'OutOfStock.Rae7u', dm: '集货缺货' }),
    value: 'gatherLack',
  },
];

const PICK_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'ToBeSelected.four_px', dm: '待拣选' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'Picking.four_px', dm: '拣选中' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'YJX.Selected.four_px', dm: '已拣选' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'QH.OutOfStock.four_px', dm: '缺货' }),
    value: 'L',
  },

  {
    label: $i18n.get({ id: 'YSC.Deleted.four_px', dm: '已删除' }),
    value: 'N',
  },
];

/**
 * @description 库存匹配状态
 */
const STOCK_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 0,
  },

  {
    label: $i18n.get({ id: 'ToBeMerged.four_px', dm: '待汇波' }),
    value: 1,
  },

  {
    label: $i18n.get({ id: 'InventoryMatchingFailed.four_px', dm: '库存匹配失败' }),
    // label: $i18n.get({ id: 'RemittanceFailed.four_px', dm: '汇单失败' }),
    value: 2,
  },
];

const SORT_STEP_STATUS = [
  {
    label: $i18n.get({ id: 'ScanSortingWall.four_px', dm: '扫描分拣墙' }),
    value: 'ST0001',
  },

  {
    label: $i18n.get({ id: 'ScanningTurnoverBox.four_px', dm: '扫描周转箱' }),
    value: 'ST0002',
  },

  {
    label: $i18n.get({ id: 'ScanSku.four_px', dm: '扫描SKU' }),
    value: 'ST0003',
  },

  {
    label: $i18n.get({ id: 'SkuConfirmation.four_px', dm: 'SKU确认' }),
    value: 'ST0004',
  },

  {
    label: $i18n.get({ id: 'QHWJ.OutOfStock.four_px', dm: '缺货完结' }),
    value: 'ST0005',
  },
];

// 出库去掉周转箱
const SORT_STEP_STATUSS = [
  {
    label: $i18n.get({ id: 'ScanSortingWall.four_px', dm: '扫描分拣墙' }),
    value: 'ST0001',
  },

  {
    label: $i18n.get({ id: 'ScanPickingFrame.four_px', dm: '扫描拣货框' }),
    value: 'ST0002',
  },

  {
    label: $i18n.get({ id: 'ScanSku.four_px', dm: '扫描SKU' }),
    value: 'ST0003',
  },

  {
    label: $i18n.get({ id: 'SkuConfirmation.four_px', dm: 'SKU确认' }),
    value: 'ST0004',
  },

  {
    label: $i18n.get({ id: 'QHWJ.OutOfStock.four_px', dm: '缺货完结' }),
    value: 'ST0005',
  },
];

/**
 * @description 拣选队列单号类型
 */
const PICK_SEARECH_TYPE = [
  {
    label: $i18n.get({ id: 'JXBCH.PickingNumber.four_px', dm: '拣选波次号' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'OutboundOrderNo.four_px', dm: '出库单号' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'ContainerNumber.four_px', dm: '容器号' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'PickingJobNo.four_px', dm: '拣选作业单号' }),
    value: 'Q',
  },
];

/**
 * @description 拣选队列时间类型
 */
const PICK_TIME_TYPE = [
  {
    label: $i18n.get({ id: 'CompletionTime.four_px', dm: '完成时间' }),
    value: 'M',
  },

  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'C',
  },
];

// 单号类型
const NO_TYPE = [
  {
    label: $i18n.get({ id: 'CKDDH.OutboundOrderNo.four_px', dm: '出库订单号' }),
    value: 'consignmentNoList',
  },

  {
    label: $i18n.get({ id: 'CustomerOrderNo.four_px', dm: '客户订单号' }),
    value: 'refNoList',
  },

  {
    label: $i18n.get({ id: 'LogisticsNumber.four_px', dm: '物流单号' }),
    value: 'shippingNoOrChildNumber',
  },

  {
    label: $i18n.get({ id: 'PTJYDH.PlatformTransactionNumber.four_px', dm: '平台交易单号' }),
    value: 'salesNo',
  },

  {
    label: $i18n.get({ id: 'ContainerBatchNumber.four_px', dm: '容器批次号' }),
    value: 'containerBatchNos',
  },

  {
    label: $i18n.get({ id: 'ExternalOrderNO', dm: '外部订单号' }),
    value: 'extOrderNoList',
  },
];

// 出库订单状态
const OUT_ORDER_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'Reviewed.four_px', dm: '已审核' }),
    value: 'A',
  },

  {
    label: $i18n.get({ id: 'PendingOrder.four_px', dm: '待汇单' }),
    value: 'N',
  },

  // {
  //   label: $i18n.get({ id: 'Matched.four_px', dm: '已匹配' }),
  //   value: 'U',
  // },

  {
    label: $i18n.get({ id: 'RemittanceInProgress.four_px', dm: '汇单中' }),
    value: 'W',
  },

  {
    label: $i18n.get({ id: 'OrdersReceived.four_px', dm: '已汇单' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'JHZ.Picking.four_px', dm: '拣货中' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'PickedUp.four_px', dm: '已拣货' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'SortingInProgress.four_px', dm: '分拣中' }),
    value: 'Q',
  },

  {
    label: $i18n.get({ id: 'Sorted.four_px', dm: '已分拣' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'Packaging.four_px', dm: '打包中' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'Packaged.four_px', dm: '已打包' }),
    value: 'K',
  },

  {
    label: $i18n.get({ id: 'PartiallyShipped', dm: '部分出库' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'OutOfStock.four_px', dm: '已出库' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'Canceled.four_px', dm: '已取消' }),
    value: 'X',
  },

  {
    label: $i18n.get({ id: 'OutboundException.four_px', dm: '出库异常' }),
    value: 'E',
  },

  {
    label: $i18n.get({ id: 'InCollection', dm: '集货中' }),
    value: 'B',
  },

  {
    label: $i18n.get({ id: 'Collated.1iJ1Z', dm: '已集货' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'InOnePoint', dm: '一分中' }),
    value: 'G',
  },

  {
    label: $i18n.get({ id: 'OnePoint', dm: '已一分' }),
    value: 'H',
  },
];

// 出库单拦截状态
const OUT_ORDER_STATUS_INTERCEPT = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'NotIntercepted', dm: '未拦截' }),
    value: 'NOT_INTERCEPTED',
  },

  {
    label: $i18n.get({ id: 'ToBeIntercepted', dm: '待拦截' }),
    value: 'INTERCEPT_REQUESTED',
  },

  {
    label: $i18n.get({ id: 'Intercepted', dm: '已拦截' }),
    value: 'INTERCEPT_CONFIRMED',
  },
];

const OUT_ORDER_STATUS_INTERCEPT_POINT = [
  {
    label: $i18n.get({ id: 'BeforePacking', dm: '打包前' }),
    value: 'PRE_PACK',
  },

  {
    label: $i18n.get({ id: 'Packaging.four_px', dm: '打包中' }),
    value: 'PACKING',
  },
];

// 出库单类型
const OUT_ORDER_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'StandardOutbound.four_px', dm: '标准出库' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'UnshelvingAndDestroying.four_px', dm: '下架销毁' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'OtherOrders.four_px', dm: '其他委托单' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'TransferOrder.four_px', dm: '调拨委托单' }),
    value: 'T',
  },

  {
    label: $i18n.get({ id: 'ReturnOrder.four_px', dm: '退仓委托单' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'StandardPowerOfAttorney.four_px', dm: '标准委托单' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'DropshippingOutboundOrder.four_px', dm: 'DropShipping出库委托单' }),
    value: 'DS',
  },
];

// 出库时间类型
const OUT_TIME_TYPE = [
  {
    label: $i18n.get({ id: 'ReviewTime.four_px', dm: '审核时间' }),
    value: 'approveTime',
  },

  {
    label: $i18n.get({ id: 'Created.four_px', dm: '创建时间' }),
    value: 'createTime',
  },

  {
    label: $i18n.get({ id: 'PackagingTime.four_px', dm: '打包时间' }),
    value: 'packCompleteTime',
  },

  {
    label: $i18n.get({ id: 'OutboundTime.four_px', dm: '出库时间' }),
    value: 'completeTime',
  },

  {
    label: $i18n.get({ id: 'EstimatedOutboundTime.four_px', dm: '预计出库时间' }),
    value: 'expectedOutboundTime',
  },

  {
    label: $i18n.get({ id: 'PresortingTimeForReturnedPartsOf_566042200', dm: '服务商退件预分拣时间' }),
    value: 'preSortOperateTime',
  },
  {
    label: $i18n.get({ id: 'DWSMeasurementTime', dm: 'DWS测量时间' }),
    value: 'dwsMeasureTime',
  },
];

// 时间类型，开始时间-完成时间
const START_COMPLETE_TIME = [
  {
    label: $i18n.get({ id: 'StartTime.four_px', dm: '开始时间' }),
    value: 'beginTime',
  },

  {
    label: $i18n.get({ id: 'CompletionTime.four_px', dm: '完成时间' }),
    value: 'completeTime',
  },
];

// 换号类型
const CHANGE_NO_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'ChangedNumberSuccess.four_px', dm: '换号成功' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'ChangedNumberFailed.four_px', dm: '换号失败' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'NoChange.four_px', dm: '未换号' }),
    value: 'W',
  },
];

// 退货类型
const RETURN_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'UnreturnedParts.four_px', dm: '未退件' }),
    value: 'N',
  },

  {
    label: $i18n.get({ id: 'ServiceProviderReturn.four_px', dm: '服务商退件' }),
    value: 'R1',
  },

  {
    label: $i18n.get({ id: 'GrsReturned.four_px', dm: 'GRS退件' }),
    value: 'R2',
  },
];

// 退回口岸
const RETURN_PORT = [
  {
    label: $i18n.get({ id: 'DongguanPort', dm: '东莞口岸' }),
    value: 'DGM',
  },

  {
    label: $i18n.get({ id: 'HunchunPort', dm: '珲春口岸' }),
    value: 'YNJ',
  },
];

// 订单来源
const OUT_ORDER_ORIGIN = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: 'AE4PL',
    value: 'AE4PL2',
  },

  {
    label: 'ebay',
    value: 'EF4PL',
  },

  {
    label: $i18n.get({ id: 'WebsiteOrder.four_px', dm: '网站下单' }),
    value: 'WEB',
  },

  {
    label: 'GFC',
    value: 'GFC',
  },

  {
    label: 'EF4PL',
    value: 'MF4PL',
  },

  {
    label: $i18n.get({ id: 'CainiaoAe.four_px', dm: '菜鸟AE' }),
    value: 'AE3PL',
  },

  {
    label: 'API',
    value: 'API',
  },

  {
    label: 'OPEN-API',
    value: 'OMS',
  },

  {
    label: $i18n.get({ id: 'QiMen.four_px', dm: '奇门' }),
    value: 'QIMEN',
  },

  {
    label: $i18n.get({ id: 'CainiaoOverseasWarehouse.four_px', dm: '菜鸟海外仓' }),
    value: 'OVERSEA',
  },

  {
    label: $i18n.get({ id: 'CainiaoHeadCourse.four_px', dm: '菜鸟头程' }),
    value: 'FIRSTLEG',
  },

  {
    label: $i18n.get({ id: 'SuningGermanyWarehouse.four_px', dm: '苏宁德国仓' }),
    value: 'SUNINGDE',
  },

  {
    label: 'DS',
    value: 'PT',
  },

  {
    label: 'ICBU',
    value: 'ICBU',
  },

  {
    label: 'MF3PL',
    value: 'MF',
  },

  // {
  //   label: $i18n.get({ id: 'QT.Other.four_px', dm: '其他' }),
  //   value: '',
  // },
];

const OUT_CAR_STATUS = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'Shipped.four_px', dm: '已发货' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'Unshipped.four_px', dm: '未发货' }),
    value: 'N',
  },
];

const OUT_SEARCH_DROPDOWN = [
  {
    label: $i18n.get({ id: 'OutboundOrderNo.four_px', dm: '出库单号' }),
    value: 'consignmentNos',
  },
  {
    label: $i18n.get({ id: 'LogisticsNumber.four_px', dm: '物流单号' }),
    value: 'shippingNos',
  },

  {
    label: $i18n.get({ id: 'PTJYDH.PlatformTransactionNumber.four_px', dm: '平台交易单号' }),
    value: 'salesNos',
  },
];

const INSPECT_SEARCH_DROPDOWN = [
  {
    label: $i18n.get({ id: 'OutboundOrderNo.four_px', dm: '出库单号' }),
    value: 'consignmentNoList',
  },
  {
    label: $i18n.get({ id: 'LogisticsNumber.four_px', dm: '物流单号' }),
    value: 'shippingNoList',
  },
  {
    label: $i18n.get({ id: 'PTJYDH.PlatformTransactionNumber.four_px', dm: '平台交易单号' }),
    value: 'salesNoList',
  },
];

const INSPECT_SKU_SEARCH_DROPDOWN = [
  {
    label: $i18n.get({ id: 'OutboundOrderNo.four_px', dm: '出库单号' }),
    value: 'consignmentNoList',
  },
  {
    label: $i18n.get({ id: 'LogisticsNumber.four_px', dm: '物流单号' }),
    value: 'shippingNoList',
  },
  {
    label: $i18n.get({ id: 'PTJYDH.PlatformTransactionNumber.four_px', dm: '平台交易单号' }),
    value: 'salesNoList',
  },
  {
    label: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
    value: 'skuCodeList',
  },
  {
    label: $i18n.get({ id: 'SKUTM.SkuBarCode.four_px', dm: '平台交易单号' }),
    value: 'productCodeList',
  },
];

const OUT_PICK_STATUS = [
  // {
  //   label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
  //   value: '',
  // },

  {
    label: $i18n.get({ id: 'InProgress.four_px', dm: '进行中' }),
    value: 'I',
  },

  {
    label: $i18n.get({ id: 'Completed.four_px', dm: '已完成' }),
    value: 'C',
  },
];

const OUT_OPERATE_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: $i18n.get({ id: 'JH.Picking.four_px', dm: '拣货' }),
    value: 'PI',
  },

  {
    label: $i18n.get({ id: 'Sorting.four_px', dm: '分拣' }),
    value: 'ST',
  },

  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'PA',
  },

  {
    label: $i18n.get({ id: 'Delivery.four_px', dm: '发货' }),
    value: 'SH',
  },

  {
    label: $i18n.get({ id: 'List.four_px', dm: '清单' }),
    value: 'CLD',
  },

  {
    label: $i18n.get({ id: 'Binding.four_px', dm: '绑定' }),
    value: 'BINDING_PARCEL_SUBOR',
  },
  {
    label: $i18n.get({ id: 'Loading.aVhO7', dm: '装车' }),
    value: 'DP',
  },
  {
    label: $i18n.get({ id: 'CodePlate', dm: '码板' }),
    value: 'PLTB',
  },

  {
    label: $i18n.get({ id: 'Punch.four_px', dm: '打托' }),
    value: 'PMSC',
  },

  {
    label: $i18n.get({ id: 'Measurement', dm: '测量' }),
    value: 'PMSM',
  },
];

const PICK_TYPE = [
  {
    label: $i18n.get({ id: 'Chosen.four_px', dm: '拣选' }),
    value: 'JX',
  },

  {
    label: $i18n.get({ id: 'Walking.four_px', dm: '行走' }),
    value: 'XZ',
  },
];

const PICK_STEP_TYPE = [
  {
    label: $i18n.get({ id: 'Chosen.four_px', dm: '拣选' }),
    value: 'PI0001',
  },

  {
    label: $i18n.get({ id: 'ScanningTurnoverBox.four_px', dm: '扫描周转箱' }),
    value: 'PI0002',
  },

  {
    label: $i18n.get({ id: 'ScanLocation.four_px', dm: '扫描库位' }),
    value: 'PI0003',
  },

  {
    label: $i18n.get({ id: 'SkipTheLocation.four_px', dm: '跳过库位' }),
    value: 'PI0004',
  },

  {
    label: $i18n.get({ id: 'AddATurnoverBox.four_px', dm: '添加周转箱' }),
    value: 'PI0005',
  },

  {
    label: $i18n.get({ id: 'SMsku.ScanSku.four_px', dm: '扫描sku' }),
    value: 'PI0006',
  },

  {
    label: $i18n.get({ id: 'QH.OutOfStock.four_px', dm: '缺货' }),
    value: 'PI0007',
  },

  {
    label: $i18n.get({ id: 'SubmitSku.four_px', dm: '提交sku' }),
    value: 'PI0008',
  },
];

const PICK_STEP_TYPES = [
  {
    label: $i18n.get({ id: 'Chosen.four_px', dm: '拣选' }),
    value: 'PI0001',
  },

  {
    label: $i18n.get({ id: 'ScanPickingFrame.four_px', dm: '扫描拣货框' }),
    value: 'PI0002',
  },

  {
    label: $i18n.get({ id: 'ScanLocation.four_px', dm: '扫描库位' }),
    value: 'PI0003',
  },

  {
    label: $i18n.get({ id: 'SkipTheLocation.four_px', dm: '跳过库位' }),
    value: 'PI0004',
  },

  {
    label: $i18n.get({ id: 'AddPickingBox.four_px', dm: '添加拣货框' }),
    value: 'PI0005',
  },

  {
    label: $i18n.get({ id: 'SMsku.ScanSku.four_px', dm: '扫描sku' }),
    value: 'PI0006',
  },

  {
    label: $i18n.get({ id: 'QH.OutOfStock.four_px', dm: '缺货' }),
    value: 'PI0007',
  },

  {
    label: $i18n.get({ id: 'SubmitSku.four_px', dm: '提交sku' }),
    value: 'PI0008',
  },

  {
    label: $i18n.get({ id: 'ScanLogisticsNumber', dm: '扫描物流单号' }),
    value: 'PI0009',
  },
];

const PACK_STEP_TYPE = [
  {
    label: $i18n.get({ id: 'DB.Packaging.four_px', dm: '打包' }),
    value: 'PC',
  },

  {
    label: $i18n.get({ id: 'PackagingLess.four_px', dm: '打包少配' }),
    value: 'PL',
  },

  {
    label: $i18n.get({ id: 'QueryPackagingDetails.four_px', dm: '查询打包详情' }),
    value: 'PD',
  },
  {
    label: $i18n.get({ id: 'Marking.four_px', dm: '打标' }),
    value: 'PM',
  },
  {
    label: $i18n.get({ id: 'ScanLogisticsNumber', dm: '扫描物流单号' }),
    value: 'PSC',
  },
  {
    label: $i18n.get({ id: 'VideoRecordingInformedLetterConf_985999605', dm: '视频录制知情函确认' }),
    value: 'PCVIL',
  },
  {
    label: $i18n.get({ id: 'ConfirmTransferOrderPacking', dm: '确认转逐单打包' }),
    value: 'PCPM',
  },
];

const DISPATCH_CAR_STEP_TYPE = [
  {
    label: $i18n.get({ id: 'ScanNumber.four_px', dm: '扫描单号' }),
    value: 'DC0001',
  },
  {
    label: $i18n.get({ id: 'Photo.four_px', dm: '拍照' }),
    value: 'DC0002',
  },
  {
    label: $i18n.get({ id: 'LoadingCompleted', dm: '装车完成' }),
    value: 'DC0003',
  },
  {
    label: $i18n.get({ id: 'Shipment.four_px', dm: '发运' }),
    value: 'DC0004',
  },
  {
    label: $i18n.get({ id: 'ConfirmTotorto', dm: '确认打托' }),
    value: 'confirm',
  },
  {
    label: $i18n.get({ id: 'CancelTototing', dm: '取消打托' }),
    value: 'cancel',
  },
  {
    label: $i18n.get({ id: 'Print.four_px', dm: '打印' }),
    value: 'print',
  },
];

const OUT_OPERATE_DETAIL_TYPE = [
  {
    label: $i18n.get({ id: 'ChangeOfReturnOrderNumber', dm: '回邮单号变更' }),
    value: 'GRLN',
  },
  {
    label: $i18n.get({ id: 'AlgorithmTagging.four_px', dm: '算法打标' }),
    value: 'AM',
  },

  {
    label: $i18n.get({ id: 'Fb4Marking.four_px', dm: 'FB4打标' }),
    value: 'FB4M',
  },

  {
    label: $i18n.get({ id: 'GenerateOutboundOrders.four_px', dm: '生成出库订单' }),
    value: 'BOO',
  },

  {
    label: $i18n.get({ id: 'ChangedNumber.four_px', dm: '换号' }),
    value: 'CNUM',
  },

  {
    label: $i18n.get({ id: 'OrderCancellation.four_px', dm: '订单取消' }),
    value: 'CO',
  },

  {
    label: $i18n.get({ id: 'OrderInterception.four_px', dm: '订单拦截' }),
    value: 'IO',
  },

  {
    label: $i18n.get({ id: 'StatusChange.four_px', dm: '状态变更' }),
    value: 'STUS',
  },

  {
    label: $i18n.get({ id: 'SelfLifting.four_px', dm: '自提' }),
    value: 'SD',
  },

  {
    label: $i18n.get({ id: 'List.four_px', dm: '清单' }),
    value: 'CLD',
  },

  {
    label: $i18n.get({ id: 'PackageCheckoutInformationUpdate', dm: '包裹签出信息更新' }),
    value: 'PARCEL_UPDATE',
  },

  {
    label: $i18n.get({ id: '2BSynchronousSelfliftingTime', dm: '2B同步自提时间' }),
    value: 'OTSPT',
  },
  {
    label: $i18n.get({ id: 'ProductTypeChange', dm: '产品类型变更' }),
    value: 'PTC',
  },
  {
    label: $i18n.get({ id: 'WarehouseRemarksChange', dm: '仓库备注变更' }),
    value: 'OWRC',
  },
  {
    label: $i18n.get({ id: 'PackingPackingMaterialInformatio_2091086792', dm: '打包包材信息更新' }),
    value: 'UPP',
  },
];

const OUTBOUND_BUSINESS_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'OtherOutbound.four_px', dm: '其他出库' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'WarehouseWithdrawal.four_px', dm: '退仓出库' }),
    value: 'R',
  },

  {
    label: $i18n.get({ id: 'StandardOutbound.four_px', dm: '标准出库' }),
    value: 'S',
  },

  {
    label: $i18n.get({ id: 'UnshelvingAndDestroying.four_px', dm: '下架销毁' }),
    value: 'D',
  },

  {
    label: $i18n.get({ id: 'TransferOrder.four_px', dm: '调拨委托单' }),
    value: 'T',
  },
];

const EXCEPTIONITEMS = [
  {
    label: $i18n.get({ id: 'ThePhysicalObjectDoesNotMatch_3427989838.four_px', dm: '实物和SKU注册信息不符' }),
    value: '1',
  },

  {
    label: $i18n.get({ id: 'SkuLogisticsPackagingDoesNotMatch.four_px', dm: 'SKU物流包装不符' }),
    value: '2',
  },

  {
    label: $i18n.get({ id: 'TheActualSizeOfSkuDoes_1432735400.four_px', dm: 'SKU实际尺重不符' }),
    value: '3',
  },

  {
    label: $i18n.get({ id: 'DamagedSku.four_px', dm: 'SKU破损' }),
    value: '4',
  },
  {
    label: $i18n.get({ id: 'SKUSuperForecastQuantity', dm: 'SKU超预报数量' }),
    value: '99',
  },

  {
    label: 'VAS',
    value: '5',
  },

  {
    label: $i18n.get({ id: 'Destruction.four_px', dm: '销毁' }),
    value: '6',
  },

  {
    label: $i18n.get({ id: 'LostAfterVerification.four_px', dm: '查验后丢失' }),
    value: '7',
  },

  {
    label: $i18n.get({ id: 'UnrecognizedSku.four_px', dm: '无法识别的SKU' }),
    value: '8',
  },

  {
    label: $i18n.get({ id: 'SkuOutsideTheForecast.four_px', dm: '预报外的SKU' }),
    value: '9',
  },

  {
    label: $i18n.get({ id: 'TheUnIdUnLiveVersion_543775843.four_px', dm: '缺少UN标识（UN带电版本）' }),
    value: '10',
  },
  {
    label: $i18n.get({ id: 'AbnormalQuality', dm: '质量异常' }),
    value: 'E01',
  },

  {
    label: $i18n.get({ id: 'Exceptions', dm: '多货异常' }),
    value: 'E02',
  },

  {
    label: $i18n.get({ id: 'MultiproductAbnormality', dm: '多品异常' }),
    value: 'E03',
  },

  {
    label: $i18n.get({ id: 'BarcodeMissingException', dm: '条码缺失异常' }),
    value: 'E04',
  },

  {
    label: $i18n.get({ id: 'AbnormalGoods', dm: '少货异常' }),
    value: 'E05',
  },

  {
    label: $i18n.get({ id: 'AbnormalValidityPeriod', dm: '效期异常' }),
    value: 'E07',
  },
  {
    label: $i18n.get({ id: 'AbnormalBoxMark', dm: '箱唛异常' }),
    value: 'E08',
  },
  {
    label: $i18n.get({ id: 'TheClosedOrderNeedsToBePutOn', dm: '已关单需上架' }),
    value: 'E09',
  },
];

/**
 * @description 拣选队列列表搜索
 * Q队列/P拣选/C周转/O出库
 */
const PICK_SEARECHS = [
  {
    label: $i18n.get({ id: 'JXBCH.PickingNumber.four_px', dm: '拣选波次号' }),
    value: 'P',
  },

  {
    label: $i18n.get({ id: 'ContainerNumber.four_px', dm: '容器号' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'PickingJobNo.four_px', dm: '拣选作业单号' }),
    value: 'Q',
  },
];

/**
 * 出库订单 --- 产品类型
 */
const OUTBOUND_PRODUCT_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: '2B',
    value: '2B',
  },

  {
    label: '2C',
    value: '2C',
  },

  // {
  //   label: 'OT',
  //   value: 'OT',
  // },
];

/**
 * 出库订单 --- BMG品牌字段
 */
const OUTBOUND_BMG_BRAND_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },

  {
    label: 'Duchamp',
    value: 'Duchamp',
  },

  {
    label: 'Penfield',
    value: 'Penfield',
  },

  {
    label: 'Peckham Rye',
    value: 'Peckham Rye',
  },

  {
    label: 'USPA',
    value: 'USPA',
  },

  {
    label: 'AUSP',
    value: 'AUSP',
  },

  {
    label: 'JLP',
    value: 'JLP',
  },

  {
    label: 'Debenhams',
    value: 'Debenhams',
  },

  {
    label: 'FLYERS',
    value: 'FLYERS',
  },
];

const OUTBOUND_PICK_ORDER_TYPE = [
  {
    label: $i18n.get({ id: 'CKDDH.OutboundOrderNo.four_px', dm: '出库订单号' }),
    value: 'consignmentNos',
  },

  {
    label: $i18n.get({ id: 'CustomerOrderNo.four_px', dm: '客户订单号' }),
    value: 'refNos',
  },
  {
    label: $i18n.get({ id: 'AssociatedDocumentNumberQuery', dm: '关联单号查询' }),
    value: 'vtaskNos',
  },
];

/**
 * 手工汇波
 * 汇单失败原因
 */
const OUTBOUND_REMITTANCE_SLIP_FAILURE = [
  {
    label: $i18n.get({ id: 'TheStorageLocationIsDisabled.four_px', dm: '库位已禁用' }),
    value: 'MATCH_INVENTORY_CELL_NOT_VALID',
  },

  {
    label: $i18n.get({ id: 'InsufficientAvailableInventory.four_px', dm: '可用库存不足' }),
    value: 'MATCH_INVENTORY_RESOURCE_NOT_ENOUGH',
  },

  {
    label: $i18n.get({ id: 'InsufficientAvailableStockStockN_1681215374', dm: '可用库存不足（拦截订单未释放库存）' }),
    value: 'MATCH_INVENTORY_RESOURCE_NOT_ENOUGH_BY_INTERCEPT',
  },

  {
    label: $i18n.get({ id: 'FailedToMatchBulkInventory.four_px', dm: '批量库存匹配失败' }),
    value: 'BATCH_MATCH_INVENTORY_RESOURCE_NOT_ENOUGH',
  },

  {
    label: $i18n.get({ id: 'InsufficientAvailableInventoryInTheLabor_3007386361.four_px', dm: '人工区可用库存不足' }),
    value: 'MATCH_PERSON_INVENTORY_RESOURCE_NOT_ENOUGH',
  },

  {
    label: $i18n.get({ id: 'InventoryHasBeenBanned', dm: '库存已过禁售' }),
    value: 'INVENTORY_MATCH_EXPIRY_FILTER',
  },
];

/**
 * 出库配置
 */
const COLLECT_WAVE_TYPE = [
  {
    label: 'MOS',
    value: 'MOS',
  },

  {
    label: 'MOD',
    value: 'MOD',
  },

  {
    label: 'SO',
    value: 'SO',
  },

  {
    label: 'S',
    value: 'S',
  },
];

const PICK_MODE = [
  {
    label: $i18n.get({ id: 'Chosen.four_px', dm: '拣选' }),
    value: 'normal',
  },

  {
    label: $i18n.get({ id: 'QuickPick.four_px', dm: '快拣' }),
    value: 'pickPack',
  },

  {
    label: $i18n.get({ id: 'PickAndDivide.four_px', dm: '边拣边分' }),
    value: 'pickAssort',
  },

  {
    label: $i18n.get({ id: 'BluetoothPrinterPicking.four_px', dm: '蓝牙打印机拣货' }),
    value: 'printLabelPick',
  },

  {
    label: $i18n.get({ id: 'VasPick', dm: 'VasPick' }),
    value: 'vasPick',
  },
];

const IS_LOGISTICS_PACKAGING = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: 'all',
  },

  {
    label: $i18n.get({ id: 'SelfContainedLogisticsPackaging.four_px', dm: '自带物流包装' }),
    value: 'C',
  },

  {
    label: $i18n.get({ id: 'NonSelfContainedPackaging.four_px', dm: '非自带包装' }),
    value: 'N',
  },
];

const OUT_SKU_QUERY = [
  {
    label: $i18n.get({ id: 'SkuEncoding.four_px', dm: 'SKU编码' }),
    value: 'skuCodes',
  },

  {
    label: $i18n.get({ id: 'SKUTM.SkuBarCode.four_px', dm: 'SKU条码' }),
    value: 'skuIdOrProductCodes',
  },
];

export const BUSINESSTYPERETURN = [
  {
    value: 'AE_VENDOR',
    label: $i18n.get({ id: 'AEFullyManaged', dm: 'AE全托管' }),
  },
  {
    value: 'AE_CHOICE2',
    label: $i18n.get({ id: 'AESemimanaged', dm: 'AE半托管' }),
  },
  {
    value: 'AE_POP',
    label: $i18n.get({ id: 'AEPlatformProvider', dm: 'AE平台商' }),
  },
  {
    value: 'AE_SELF',
    label: $i18n.get({ id: 'AESelfemployed', dm: 'AE自营商' }),
  },
];

/**
 * 集货、一分
 * 订单类型
 */
const SORTING_COLLECT_TASK_TYPE = [
  {
    label: $i18n.get({ id: 'OnetwoPoints', dm: '一分二分' }),
    value: 'MOD-AGG',
  },
];

/**
 * 集货类型(一分集货、拆单集货)
 */
const GATHER_TYPE = [
  {
    label: $i18n.get({ id: 'SplitAndCollectGoods', dm: '拆单集货' }),
    value: 'SPLIT',
  },

  {
    label: $i18n.get({ id: 'SortingAndCollectingGoods', dm: '分拣集货' }),
    value: 'PRE_ASSORT',
  },
];

/**
 * 拣选单操作日志的操作类型
 */
const PICK_OPERATE_TYPE = [
  {
    label: $i18n.get({ id: 'Modify.four_px', dm: '修改' }),
    value: 'UPDATE',
  },

  {
    label: $i18n.get({ id: 'Empty.four_px', dm: '清空' }),
    value: 'REMOVE',
  },

  {
    label: $i18n.get({ id: 'Add.four_px', dm: '新增' }),
    value: 'ADD',
  },

  {
    label: $i18n.get({ id: 'OrderInterception.four_px', dm: '订单拦截' }),
    value: 'INTERCEPT',
  },

  {
    label: $i18n.get({ id: 'Delete.four_px', dm: '删除' }),
    value: 'DELETE',
  },
];

/**
 * 拣选单操作日志的描述
 */
const DESC_MSG = [
  {
    label: $i18n.get({ id: 'Operator.four_px', dm: '操作人' }),
    value: 'OPERATOR',
  },

  {
    label: $i18n.get({ id: 'Urgent', dm: '是否加急' }),
    value: 'IS_URGENT',
  },

  {
    label: $i18n.get({ id: 'Manual.four_px', dm: '手动删除' }),
    value: 'MANUAL_DELETE',
  },

  {
    label: $i18n.get({ id: 'Automatic.four_px', dm: '自动删除' }),
    value: 'AUTO_DELETE',
  },

  {
    label: $i18n.get({ id: 'OrderInterception.four_px', dm: '订单拦截' }),
    value: 'INTERCEPT',
  },
];

export const GATHERTYPE_LIST = [
  {
    label: $i18n.get({ id: 'NoCollection', dm: '不集货' }),
    value: 'NONE',
  },
  {
    label: $i18n.get({ id: 'OnePointForGoodsCollection', dm: '集货一分' }),
    value: 'PRE_ASSORT',
  },
  {
    label: $i18n.get({ id: 'CollectionDismantlingDoc', dm: '集货拆单' }),
    value: 'SPLIT',
  },
];

export const REPICK_TYPE = [
  {
    label: $i18n.get({ id: 'All.four_px', dm: '全部' }),
    value: '',
  },
  {
    label: $i18n.get({ id: 'NoncomplexPicking', dm: '非复拣' }),
    value: 'N',
  },
  {
    label: $i18n.get({ id: 'SplitAndCollectGoodsForRepicking', dm: '拆单集货复拣' }),
    value: 'S',
  },
  {
    label: $i18n.get({ id: 'StandardOutboundRepicking', dm: '标准出库复拣' }),
    value: 'C',
  },
];

// 出库时间类型
const DWS_TIME_TYPE = [
  {
    label: $i18n.get({ id: 'PackagingTime.four_px', dm: '打包时间' }),
    value: 'packTime',
  },

  {
    label: $i18n.get({ id: 'OutboundTime.four_px', dm: '出库时间' }),
    value: 'deliveryTime',
  },
  {
    label: $i18n.get({ id: 'MeasurementTime.four_px', dm: '测量时间' }),
    value: 'measureTime',
  },
];

/**
 * @description 稽查结果 符合/不符合
 */
const INSPECT_RESULT = [
  {
    label: $i18n.get({ id: 'Compliance', dm: '符合' }),
    value: 'Y',
  },

  {
    label: $i18n.get({ id: 'NotInConformity', dm: '不符合' }),
    value: 'N',
  },
];

/**
 * 装笼模式
 */
const CAGE_MODE = [
  {
    label: $i18n.get({ id: 'PackagingCageIntegrated', dm: '包装装笼一体' }),
    value: 'PCI',
  },
  {
    label: $i18n.get({ id: 'PackingCageSeparation', dm: '包装装笼分离' }),
    value: 'PCS',
  },
];

const PICK_PRODUCT_TYPE = [
  {
    label: $i18n.get({ id: 'productType.2C', dm: '2C' }),
    value: '2C',
  },

  {
    label: $i18n.get({ id: 'productType.2B', dm: '2B' }),
    value: '2B',
  },
  {
    label: $i18n.get({ id: 'productType.mix', dm: '(mix)' }),
    value: '(mix)',
  },
];

const BUSINESS_TYPE = [
  {
    label: $i18n.get({ id: 'OtherOutbound.four_px', dm: '其他出库' }),
    value: 'O',
  },

  {
    label: $i18n.get({ id: 'WarehouseWithdrawal.four_px', dm: '退仓出库' }),
    value: 'R',
  },
  {
    label: $i18n.get({ id: 'StandardOutbound.four_px', dm: '标准出库' }),
    value: 'S',
  },
  {
    label: $i18n.get({ id: 'UnshelvingAndDestroying.four_px', dm: '下架销毁' }),
    value: 'D',
  },
  {
    label: $i18n.get({ id: 'TransferOrder.four_px', dm: '调拨委托单' }),
    value: 'T',
  },
  {
    label: $i18n.get({ id: 'productType.mix', dm: '(mix)' }),
    value: '(mix)',
  },
];

const ORDER_WAVE_SOURCE = [
  {
    label: $i18n.get({ id: 'M_V2.four_px', dm: '手工' }),
    value: 'manual',
  },
  {
    label: $i18n.get({ id: 'Automatic.four_px', dm: '自动' }),
    value: 'auto',
  },
];

const ORDER_WAVE_STATUS = [
  { value: 'INIT_CREATE', label: $i18n.get({ id: 'ToBeImplemented', dm: '待执行' }) },
  { value: 'IN_EXECUTION', label: $i18n.get({ id: 'Executing.four_px', dm: '执行中' }) },
  { value: 'EXEC_COMPLETE', label: $i18n.get({ id: 'EXEC_COMPLETE', dm: '执行完成' }) },
  { value: 'EXEC_EXCEPTION', label: $i18n.get({ id: 'ExecutionException.R8sRM', dm: '执行异常' }) },
];
const MAXCARGOTYPE = [
  {
    value: 'S',
    label: 'T25',
  },
  {
    value: 'M',
    label: 'T50',
  },
  {
    value: 'L',
    label: 'T120',
  },
  {
    value: 'O',
    label: 'T240',
  },
  {
    value: 'W',
    label: 'TM',
  },
];

const VAS_RELATION = [
  {
    label: $i18n.get({ id: 'AllAssociations', dm: '全部关联' }),
    value: 'ALL_VAS',
  },
  {
    label: $i18n.get({ id: 'PartialAssociation', dm: '部分关联' }),
    value: 'PART_VAS',
  },
  {
    label: $i18n.get({ id: 'NotAssociated', dm: '未关联' }),
    value: 'NO_VAS',
  },
];

const ORIGINAL_BOX_MATERIAL = [
  {
    label: 'SLP001',
    value: 'SLP001',
  },
  {
    label: 'C',
    value: 'C',
  },
  {
    label: 'SIOP',
    value: 'SIOP',
  },
  {
    label: 'YX001',
    value: 'YX001',
  },
  { label: '(mix)', value: '(mix)' },
];

const PACK_TYPE = [
  {
    label: $i18n.get({ id: 'BatchPackaging', dm: '批量打包' }),
    value: 'batchPacking',
  },
  {
    label: $i18n.get({ id: 'PackOneByOne', dm: '逐单打包' }),
    value: 'normalPacking',
  },
];

const OPERATION_OUTBOUND_URL = '/outbound/giws/operation/outbound';
const OUTBOUND_URL = '/portal';

export {
  OUTBOUND,
  RETURN_PORT,
  SORT_STATUS,
  ORDER_TYPE,
  ZONECODE_TYPE,
  MANUALREMIT_TIME,
  CHANNEL,
  PICK_ORDER_STATUS,
  CARGO_TYPE,
  WAREHOUSE_AREAR,
  ORDER_ORIGIN,
  PICK_SEARECH,
  PICK_STATUS,
  PICK_TAB_STATUS,
  STOCK_STATUS,
  SORT_STEP_STATUS,
  OPERATION_OUTBOUND_URL,
  OUTBOUND_URL,
  DELIVER_STATUS,
  DELIVER_ORDER_STATUS,
  DISPATCHCAR_STATUS,
  NO_TYPE,
  OUT_ORDER_STATUS,
  OUT_ORDER_TYPE,
  OUT_TIME_TYPE,
  CHANGE_NO_TYPE,
  RETURN_TYPE,
  OUT_ORDER_ORIGIN,
  PICK_SEARECH_TYPE,
  PICK_DETAIL_SEARECH,
  PICK_TIME_TYPE,
  OUT_CAR_STATUS,
  OUT_PICK_STATUS,
  OUT_OPERATE_TYPE,
  PICK_TYPE,
  PICK_STEP_TYPE,
  PACK_STEP_TYPE,
  OUT_OPERATE_DETAIL_TYPE,
  PICK_STEP_TYPES,
  SORT_STEP_STATUSS,
  OUTBOUND_BUSINESS_TYPE,
  EXCEPTIONITEMS,
  PICK_SEARECHS,
  PICK_STRUCTURE,
  PICK_SOURCE,
  PICK_ORDER_STATUSTER,
  OUTBOUND_PRODUCT_TYPE,
  PICK_PRODUCT_TYPE,
  BUSINESS_TYPE,
  OUTBOUND_PICK_ORDER_TYPE,
  OUTBOUND_REMITTANCE_SLIP_FAILURE,
  COLLECT_WAVE_TYPE,
  PICK_MODE,
  IS_LOGISTICS_PACKAGING,
  OUT_SKU_QUERY,
  SORTING_COLLECT_TASK_TYPE,
  SKU_GROUP_ORDER_STATUS,
  OUT_SEARCH_DROPDOWN,
  PICK_OPERATE_TYPE,
  DESC_MSG,
  INSPECT_SEARCH_DROPDOWN,
  DISPATCH_CAR_STEP_TYPE,
  OUTBOUND_BMG_BRAND_TYPE,
  PICK_ABNORMAL_TAB,
  GATHER_TYPE,
  OUT_ORDER_STATUS_INTERCEPT,
  OUT_ORDER_STATUS_INTERCEPT_POINT,
  AUTO_WAVE_ORDER_TASK_TYPE,
  DWS_TIME_TYPE,
  INSPECT_RESULT,
  INSPECT_SKU_SEARCH_DROPDOWN,
  CAGE_MODE,
  ORDER_WAVE_SOURCE,
  ORDER_WAVE_STATUS,
  MAXCARGOTYPE,
  START_COMPLETE_TIME,
  VAS_RELATION,
  ORIGINAL_BOX_MATERIAL,
  PACK_TYPE,
};
